<template>
	<div>
		<PagesHeading :path2="album.title" />
		<div id="album" class="container" :class="{ 'loading-app-style': loading }">
			<div v-if="loading" class="py-5" style="display: flex; align-items: center; justify-content: center">
				<div class="loader"></div>
			</div>
			<div v-else class="row justify-content-center mt-5">
				<div  v-for="(img, index) in album.images" :key="index" class="col-12 col-sm-6 col-md-4 mb-4">
					<a class="no-decoration text-white" @click="show(album.images, index)">
						<div class="card">
							<div class="card-img-top photo border-0">
								<img :src="img.url" class="card-img-top same-height cover img-fluid rounded">
							</div>
							<div v-if="img.caption" class="card-img-overlay no-overflow text-white">
								{{ img.caption }}
							</div>
						</div>
					</a>
				</div> 
			</div>
			<lightbox     
			:visible="visible"
			:imgs="img"
			:index="index"
			@hide="hide()"></lightbox>
		</div>
	</div>
</template>
<script>
import lightbox from 'vue-easy-lightbox'
import PagesHeading from '@/components/PagesHeading.vue';
import { mapState, mapActions } from 'vuex';
export default {
	components: {
		lightbox,
		PagesHeading
	},
	data() {
		return {
			loading: true,
			visible: false,
			img: '',
			index: 0
		}
	},
	computed: {
		...mapState({
			albums: state => state.albums.albums
		}),
		album() {
			if (this.albums[0]) {
				return this.albums.find(t => t.slug === this.$route.params.slug);
			} else {
				return '';
			}
		}
	},
	methods: {
		...mapActions('albums', ['fetchAlbums']),
		fetch() {
			if (!this.albums[0]) {
				this.fetchAlbums()
					.finally(() => { this.loading = false; });
			} else {
				this.loading = false
			}
		},
		show(images, i) {
			const urls = [];
			for (let i = 0; i < images.length; i++) { 
				urls.push(images[i].url);
			}
			this.index = i;
			this.img = urls;
			this.visible = true;
		},
		hide() {
			this.visible = false;
		}
	},
	created() {
		this.fetch();
	}
}
</script>
<style scoped>
body {
	background-color: #fff;
}

img.same-height {
	height: 280px;
}

.cover {
	object-fit: cover;
}

.card-img-overlay {
	position: absolute;
	top: calc(280px - 1.5rem - 16px);
	right: 0;
	bottom: 0;
	left: 0;
	background: rgba(0, 0, 0, 0.6);
	padding: 8px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.card {
	overflow: hidden;
	position: relative;
}

.card img {
	transition: all .5s;
	width: 100%;
	height: 300px;
}

.card:hover img {
	transform: rotate(-10deg) scale(1.5);

}

@media (max-width: 520px) and (min-width: 380px) {
	.card {
		margin: 0px 10% !important;
	}
}

@media (max-width: 380px) {
	.card {
		margin: 0px 10% !important;
	}
}

.loader {
	border: 8px solid #f3f3f3;
	/* Light grey */
	border-top: 8px solid #fcad4d;
	/* Blue */
	border-radius: 50%;
	width: 60px;
	height: 60px;
	animation: spin 2s linear infinite;
	margin: 0 auto;
	/* position: absolute;
  top: 70%;
  bottom: 50% */
}
</style>